import React from "react";
import AccordionEditable from "../../../../../components/ui/accordions/AccordionEditable";
import ContentCard from "../../../../../components/ui/cards/ContentCard";

const AdditionalNotesSection = ({ filing }) => {
  const ptfDescription =
    filing.tax_situation?.details?.PTF?.situation?.description;
  const btfDescription =
    filing.tax_situation?.details?.BTF?.situation?.description;

  // Gatekeeper: If there are no notes for either service, don't render anything
  if (!ptfDescription && !btfDescription) {
    return null;
  }

  return (
    <AccordionEditable
      key="additional-notes"
      title="Additional Notes"
      hasRequiredActions={false}
      allActionsComplete={true}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* Personal Notes */}
        {ptfDescription && (
          <ContentCard style={{ borderRadius: "0" }}>
            <h4
              style={{
                margin: 0,
                fontSize: "16px",
                fontWeight: "600",
                color: "#004789",
              }}
            >
              Personal
            </h4>
            <span
              style={{
                fontSize: "14px",
                color: "#1A2127",
                whiteSpace: "pre-wrap",
              }}
            >
              {ptfDescription}
            </span>
          </ContentCard>
        )}

        {/* Business Notes */}
        {btfDescription && (
          <ContentCard style={{ borderRadius: "0" }}>
            <h4
              style={{
                margin: 0,
                fontSize: "16px",
                fontWeight: "600",
                color: "#004789",
              }}
            >
              Business
            </h4>
            <span
              style={{
                fontSize: "14px",
                color: "#1A2127",
                whiteSpace: "pre-wrap",
              }}
            >
              {btfDescription}
            </span>
          </ContentCard>
        )}
      </div>
    </AccordionEditable>
  );
};

export default AdditionalNotesSection;
